import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=75253b84&scoped=true"
import script from "./specification.vue?vue&type=script&lang=ts"
export * from "./specification.vue?vue&type=script&lang=ts"
import style0 from "./specification.vue?vue&type=style&index=0&id=75253b84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75253b84",
  null
  
)

export default component.exports